/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { AdminNewsListNewsForPlannerFragmentDoc } from '../../features/adminNews/components/AdminNewsList/AdminNewsList.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type AdminNewsListPageQueryVariables = Exact<{
  first: number;
  after?: string | null | undefined;
}>;


export type AdminNewsListPageQuery = { newsForPlanner: { edges: Array<{ cursor: string, node: { id: string, title: string, body: string, publishedAt: TimeString } }>, pageInfo: { endCursor: string | null, hasNextPage: boolean } } };


export const AdminNewsListPageDocument = gql`
    query AdminNewsListPage($first: Int!, $after: String) {
  newsForPlanner(first: $first, after: $after) {
    edges {
      node {
        ...AdminNewsListNewsForPlanner
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${AdminNewsListNewsForPlannerFragmentDoc}`;

/**
 * __useAdminNewsListPageQuery__
 *
 * To run a query within a Vue component, call `useAdminNewsListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminNewsListPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminNewsListPageQuery({
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useAdminNewsListPageQuery(variables: AdminNewsListPageQueryVariables | VueCompositionApi.Ref<AdminNewsListPageQueryVariables> | ReactiveFunction<AdminNewsListPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminNewsListPageQuery, AdminNewsListPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminNewsListPageQuery, AdminNewsListPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminNewsListPageQuery, AdminNewsListPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminNewsListPageQuery, AdminNewsListPageQueryVariables>(AdminNewsListPageDocument, variables, options);
}
export function useAdminNewsListPageLazyQuery(variables?: AdminNewsListPageQueryVariables | VueCompositionApi.Ref<AdminNewsListPageQueryVariables> | ReactiveFunction<AdminNewsListPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminNewsListPageQuery, AdminNewsListPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminNewsListPageQuery, AdminNewsListPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminNewsListPageQuery, AdminNewsListPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminNewsListPageQuery, AdminNewsListPageQueryVariables>(AdminNewsListPageDocument, variables, options);
}
export type AdminNewsListPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminNewsListPageQuery, AdminNewsListPageQueryVariables>;